/**
 *
 * @description make sure that all validation function name are declared camelCase.
 * @description undefined indicate that value pass validaion.
 * @description Import this funtion directly from this file. Don not eport this to constant/index
 *
 */

import { ifElse } from "ramda";

export const required = value =>
  value || typeof value === "number" ? undefined : "Required Field";

export const checkHourValue = value => {
  if (value > 23) {
    return "Max 23 hr allowed";
  }
  if (value < 0) {
    return "Min 0 min allowed";
  }
};

export const checkMinValue = (value, formValues) => {
  if (
    formValues.hour === 0 ||
    formValues.hour === "" ||
    formValues.hour === "0"
  ) {
    if (value > 59) {
      return "Max 59 min allowed";
    }
    if (value < 1 && formValues.second !== "60") {
      return "Required at least 1 min";
    }
  } else {
    if (value > 59) {
      return "Max 59 min allowed";
    }
    if (value < 0) {
      return "Min 0 min allowed";
    }
  }
};

export const checkRestrictionMinValue = value => {
  if (value > 59) {
    return "Max 59 min allowed";
  }
  if (value < 0) {
    return "Min 0 min allowed";
  }
};

export const checkSecValue = value => {
  if (value > 60) {
    return "Max 60 sec allowed";
  }
  if (value < 0) {
    return "Min 0 sec required";
  }
};

export const validateRestrictionCampaignDuration = (value, formValues) => {
  const total =
    Number(formValues.campaignRestrictSecond) +
    Number(formValues.campaignRestrictMinute) * 60 +
    Number(formValues.campaignRestrictHour) * 3600;
  if (formValues.campaignRestrictionFlag && total < 15) {
    return "Min 15 sec required";
  }
};

export const number = value =>
  value && isNaN(Number(value)) ? "Must be a number" : undefined;

export const integer = value => {
  if (value === "") {
    return;
  }
  const newVal = Number(value);
  return value && Number.isInteger(newVal) ? undefined : "Must be an integer";
};

export const isName = value =>
  value && /^[a-z ,.'-]+$/i.test(value)
    ? undefined
    : "Contains Invalid Characters";

export const isPasswordStrong = value =>
  value && value.length >= 8 ? undefined : "Minimum eight characters";

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,12}$/i.test(value)
    ? "Invalid email address"
    : undefined;

export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? "Only alphanumeric characters"
    : undefined;

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? "Invalid phone number, must be 10 digits"
    : undefined;

export const fileName = value =>
  value && /[!@#$%^&*(),?":{}|<>]/g.test(value)
    ? "Invalid file name"
    : undefined;

export const validateTags = value => {
  let errorCheck = false;
  // eslint-disable-next-line
  value &&
    value.forEach(i => {
      if (i.indexOf(",") > -1 || i.indexOf(" ") > -1) {
        errorCheck = true;
      }
    });
  if (errorCheck) return "Do not use comma / space in tags.";
};

let symbolsRegEx = new RegExp(/[!@#$%^&*()|{}:"<>?,/\\]/);
export const validateSymbols = value => {
  let match = symbolsRegEx.exec(value);
  return match ? `Do not include ${value[match.index]} in name.` : undefined;
};
